import { websiteRedirectQueries } from '@/lib/services/website-redirects/website-redirects.query'
import { notFound, redirect } from '@tanstack/react-router'

export async function loadWebsiteRedirectsRoute({ context, params, requireFsnEnabled = false }) {
  if (!context.ability.can('list', 'website-redirects')) throw notFound()

  const isGlobalOrg = Number(params.orgId) === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)

  if (!isGlobalOrg) {
    const configuration = await context.queryClient.ensureQueryData(
      websiteRedirectQueries.configuration({ organizationId: params.orgId })
    )

    if (requireFsnEnabled && !configuration.fsn_legacy_url_redirects_enabled) {
      throw redirect({
        to: '/$orgId/website/url-redirects',
        params: { orgId: params.orgId },
        replace: true,
      })
    }
  }

  return {
    isGlobalOrg,
    isReadOnly: !context.ability.can('edit', 'website-redirects'),
  }
}
